const R_MI = 3958.8;
const toRad = (d) => (d * Math.PI) / 180;
const toDeg = (r) => (r * 180) / Math.PI;

/** GeoJSON polygon approximating a circle of `radiusMi` around [lng, lat]. */
export function circleFeature([lng, lat], radiusMi, steps = 96) {
  const d = radiusMi / R_MI;
  const lat1 = toRad(lat);
  const lng1 = toRad(lng);
  const coords = [];
  for (let i = 0; i <= steps; i += 1) {
    const brng = (2 * Math.PI * i) / steps;
    const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(brng));
    const lng2 = lng1 + Math.atan2(Math.sin(brng) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));
    coords.push([toDeg(lng2), toDeg(lat2)]);
  }
  return { type: "Feature", properties: {}, geometry: { type: "Polygon", coordinates: [coords] } };
}

const RING_STEPS = [5, 10, 15, 20, 30];

/** Concentric distance rings (lines + north-edge labels) up to `radiusMi`; the outer ring is the active search radius. */
export function ringsCollection([lng, lat], radiusMi) {
  const steps = [...new Set([...RING_STEPS.filter((s) => s < radiusMi), radiusMi])];
  const features = [{ ...circleFeature([lng, lat], radiusMi), properties: { kind: "area" } }];
  steps.forEach((mi) => {
    const ring = circleFeature([lng, lat], mi).geometry.coordinates[0];
    const active = mi === radiusMi;
    features.push({ type: "Feature", properties: { kind: "ring", active }, geometry: { type: "LineString", coordinates: ring } });
    features.push({ type: "Feature", properties: { kind: "label", active, label: `${mi} mi` }, geometry: { type: "Point", coordinates: ring[0] } });
  });
  return { type: "FeatureCollection", features };
}

export function lineFeature(from, to, label) {
  return {
    type: "Feature",
    properties: { label },
    geometry: { type: "LineString", coordinates: [[from.lng, from.lat], [to.lng, to.lat]] },
  };
}

export function milesBetween(a, b) {
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * R_MI * Math.asin(Math.sqrt(h)) * 10) / 10;
}

export function boundsOf(points) {
  const lngs = points.map((p) => p.lng);
  const lats = points.map((p) => p.lat);
  return [[Math.min(...lngs), Math.min(...lats)], [Math.max(...lngs), Math.max(...lats)]];
}

export const zoomForRadius = (r) => (r <= 5 ? 11.6 : r <= 10 ? 10.8 : r <= 15 ? 10.2 : r <= 20 ? 9.8 : 9.1);
